import React from 'react';
import { useTranslation } from 'react-i18next';
import s from './ActivitiesGrid.styles';

const ActivitiesGridColumns = () => {
  const { t } = useTranslation();

  return (
    <s.Columns isStatic>
      <s.Column filterType="date" name="created_at">
        {t('COLUMN_TIME')}
      </s.Column>
      <s.Column
        filterType="list"
        filterValues={[
          {
            value: 'view',
            label: t('ACTION_VIEW'),
          },
          {
            value: 'add',
            label: t('ACTION_ADD'),
          },
          {
            value: 'update',
            label: t('ACTION_UPDATE'),
          },
          {
            value: 'delete',
            label: t('ACTION_DELETE'),
          },
        ]}
        name="action"
      >
        {t('COLUMN_ACTION')}
      </s.Column>
      <s.Column order="user_id">{t('COLUMN_VIEWER_AUTHOR')}</s.Column>
    </s.Columns>
  );
};

export default React.memo(ActivitiesGridColumns);
